import { render } from "./XboxAuth.vue?vue&type=template&id=672816ac&ts=true"
import script from "./XboxAuth.vue?vue&type=script&lang=ts"
export * from "./XboxAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__